module.exports = __webpack_public_path__ + "static/media/slider-l3-768.ecc20fbc.webp";